import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faCalculator } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "../../../../hooks";
import styles from "./MonthlyAssessments.module.css";

const MonthlyAssessments = ({
	monthsToDisplay,
	groupedAssessments,
	selectedMonth,
	setSelectedMonth,
}) => {
	const { t } = useTranslation();

	return (
		<div className={styles.monthNav}>
			<div className={styles.monthNavHeader}>
				<h3 className={styles.monthNavTitle}>
					<FontAwesomeIcon icon={faCalendarAlt} />
					{t("assessment.monthlyAssessments") || "Monthly Assessments"}
				</h3>
			</div>

			<div className={styles.monthIndicators}>
				{monthsToDisplay.map((month) => {
					const monthAssessments = groupedAssessments[month] || [];
					const monthPoints = monthAssessments.reduce(
						(sum, a) => sum + Number(a.points),
						0
					);

					return (
						<div
							key={month}
							className={`${styles.monthIndicator} ${
								selectedMonth === month ? styles.active : ""
							}`}
							onClick={() => setSelectedMonth(month)}
						>
							<span className={styles.monthName}>{month}</span>
							<span className={styles.monthPoints}>
								<FontAwesomeIcon icon={faCalculator} />
								{monthPoints} {t("assessment.pts") || "pts"}
							</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default MonthlyAssessments;
